import styled from "styled-components";

const Card = styled.div`
  background-color: var(--system-background);
  border-radius: 16px;
  box-shadow: 0 11px 34px var(--shadow-color);
`;

export default Card;
